import { gql } from '@apollo/client';

export const GET_CONFIG_BY_TYPE = gql`
  query GetConfigByType($query: GetConfigByTypeInput) {
    getConfigByType(query: $query) {
      data {
        id
        img
        type
        body
      }
    }
  }
`;
